// extracted by mini-css-extract-plugin
export default {"otpInputContainer":"OTPInput_otpInputContainer__jwKRp","otpInput":"OTPInput_otpInput__LQtGP"};